const DowntimeModal = ({ message }) => {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999999,
        pointerEvents: "all",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "10px",
          width: "90%",
          maxWidth: "450px",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        }}
      >
        <h2>🚧 System Downtime</h2>

        <p style={{ marginTop: "12px", fontSize: "14px" }}>
          {message}
        </p>

        <p style={{ marginTop: "15px", fontSize: "12px", color: "#666" }}>
          This notice cannot be dismissed.
        </p>
      </div>
    </div>
  );
};

export default DowntimeModal;
